import { TypedUseSelectorHook, useSelector } from 'react-redux';

import type { RootState } from '@app/store/rootDuck';

// eslint-disable-next-line import/prefer-default-export
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
